/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { connect } from 'react-redux';
import * as actions from './BulkEdition.slice';
import { BulkEditionBar, BulkEditionWizard } from './components';
import { Light } from 'themes';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';

const BulkEditionContainer = ({
  toggleBulkEditionMode,
  getDashboardModel = noop,
  profileOptions,
  smartFilters,
  handleClose,
  handleOpen,
  applySettings,
  backButton,
  setSetting,
  setSelectedCols,
  BulkEdition,
  datePickerMinDate,
  timezone
}) => {
  const {
    isBulkEditionMode,
    selectedWidgets,
    sideBarSummary,
    isSaving,
    isOpen
  } = BulkEdition;
  const onFooterFinish = () => {
    return !isSaving && applySettings([getDashboardModel(), profileOptions]);
  };

  const toggle = () => handleOpen(!isOpen);
  const BulkEditionWithTimeZone = {...BulkEdition, ...{timezone}, ...{datePickerMinDate}};
  return (
    <React.Fragment>
      <ThemeProvider theme={Light}>
        <BulkEditionBar
          isVisible={isBulkEditionMode}
          count={selectedWidgets && selectedWidgets.length}
          onCancel={toggleBulkEditionMode}
          onNext={toggle}
        />
        <BulkEditionWizard
          isOpen={isOpen}
          onClose={toggle}
          profileOptions={profileOptions}
          smartFilters={smartFilters}
          handleClose={handleClose}
          handleOpen={handleOpen}
          setSetting={setSetting}
          setSelectedCols={setSelectedCols}
          BulkEdition={BulkEditionWithTimeZone}
          backButton={backButton}
          sideBarSummary={sideBarSummary}
          onFooterFinish={onFooterFinish}
        />
      </ThemeProvider>
    </React.Fragment>
  );
};

BulkEditionContainer.propTypes = {
  isBulkEditionMode: PropTypes.bool,
  selectedWidgets: PropTypes.array,
  toggleBulkEditionMode: PropTypes.func,
  profileOptions: PropTypes.array,
  smartFilters: PropTypes.array,
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  backButton: PropTypes.func,
  setSetting: PropTypes.func,
  setSelectedCols: PropTypes.func,
  applySettings: PropTypes.func,
  datePickerMinDate: PropTypes.object,
  getDashboardModel: PropTypes.func,
  BulkEdition: PropTypes.object,
  Views: PropTypes.object,
  timezone: PropTypes.string.isRequired,
};

const mapStateToProps = (
  (state) => ({
    BulkEdition: state.BulkEdition || {},
    timezone: state.AppUser.user.timezone
  })
);
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

export default connect(mapStateToProps, actions, mergeProps)(BulkEditionContainer);
